import RuleGroupItemParameter from './rule-group-item-parameter.entity';

export default class RuleGroupItem {
  id: string;

  name: string;

  parameters: RuleGroupItemParameter[] = [];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    if (obj.parameters) {
      this.parameters = RuleGroupItemParameter.ofList(obj.parameters)
        .sort((el: any, elb: any) => el.index - elb.index);
    }
  }

  public static of(obj: any = {}): RuleGroupItem {
    return new RuleGroupItem(obj || {});
  }

  public static ofList(obj: any[] = []): RuleGroupItem[] {
    return obj.map(this.of);
  }

  public isEmpty(): boolean {
    return this.id === '' && this.name === '' && this.parameters.length === 0;
  }
}
